<script setup>

import AppLayout from "@/Layouts/AppLayout.vue";

defineProps({
  users: Array
});
</script>

<template>
  <AppLayout title="Internal Directory">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Internal Directory
      </h2>
    </template>

    <div>
      <div class="mx-auto py-10 sm:px-6 lg:px-8">
        <table class="min-w-full w-full text-left text-sm font-light">
          <thead class="border-b font-medium dark:border-neutral-500">
          <tr>
            <th scope="col" class="px-4 py-2">First Name</th>
            <th scope="col" class="px-4 py-2 hidden md:table-cell">Last Name</th>
            <th scope="col" class="px-4 py-2 hidden md:table-cell">Title</th>
            <th scope="col" class="px-4 py-2">Email</th>
            <th scope="col" class="px-4 py-2 hidden md:table-cell">Phone Number</th>
            <th scope="col" class="px-4 py-2">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr
            class="border-b transition duration-300 ease-in-out hover:bg-neutral-200"
            v-for="user in users">
            <td class="px-4 py-2 break-words" v-text="user.firstname"></td>
            <td class="px-4 py-2 break-words hidden md:table-cell" v-text="user.lastname"></td>
            <td class="px-4 py-2 break-words hidden md:table-cell" v-text="user.title"></td>
            <td class="px-4 py-2 break-words" v-text="user.email"></td>
            <td class="px-4 py-2 break-words hidden md:table-cell" v-text="user.phone"></td>
            <td>
              <a :href="route('internal.directory.show', {user: user.employeeID})" class="fa fa-eye p-1"
                 :title="`View ${user.firstname}`">
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </AppLayout>
</template>
